module.exports = __webpack_public_path__ + "pc-top-assets/img/logo.7841ecdf.png";